





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { GoalSettingColumns } from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';
import { indexFirstInput, indexLastInput, styleCellFactory } from './utils';
import { i18nMixin } from '@/modules/neodash/mixins';
import InfoComponent from '@/modules/business-plan/common/utils/info.component.vue';

interface headerColumn {
  label: string;
  colspan: number;
}

const translate = i18nMixin.methods.i18n;

@Component({
  name: 'TableHeadGoalSettingComponent',
  components: { InfoComponent }
})
export default class TableHeadGoalSettingComponent extends Vue {
  public readonly labelResult = translate('Common.Result');
  public initialLabel = `Histórico: 2024 (JAN/DEZ) | 2025 (NOV-2024 / OUT-2025)`

  @Prop({ required: true })
  public columns: GoalSettingColumns;

  @Prop({ required: true })
  public showMonthlyValues: boolean;

  public readonly indexFirstInput = indexFirstInput(this.columns);
  public readonly indexLastInput = indexLastInput(this.columns);
  public readonly labelBusinessPlan = `Business Plan ${this.columns.nextYear}`;

  public get periodColumns(): headerColumn[] {
    const lastHalf = this.inputLength + this.resultLength;
    return [
      { label: this.labelDone(this.showMonthlyValues), colspan: this.indexFirstInput },
      { label: this.labelBusinessPlan, colspan: lastHalf }
    ];
  }

  public get parameterColumns(): headerColumn[] {
    return Array.from({ length: this.inputLength }, (x, i) => ({
      label: `Parâmetro ${i + 1}`,
      colspan: 2
    }))
  }

  public get inputLength(): number {
    return this.indexLastInput - this.indexFirstInput + 1;
  }

  public get resultLength(): number {
    return this.columns.iterator.length - this.indexFirstInput;
  }

  public labelDone(showMonthlyLabel: boolean): string {
    if (showMonthlyLabel)
      return `${this.initialLabel}`;

    return `${this.initialLabel}`;
  }

  public styleCell = styleCellFactory(this.columns);

  public hoverShowInfo(title: string) {
    this.$nextTick(() => {
      console.log(title);
      const info: any = document.querySelector(`[data-title="${title}"]`)
      info.style.display = 'block';
    });
  }

  public leaveShowInfo(title: string) {
    this.$nextTick(() => {
      const info: any = document.querySelector(`[data-title="${title}"]`)
      info.style.display = 'none';
    });
  }
}
